import { useState, useEffect } from 'react';
import { useAuth } from '../context/AuthContext';
import api from '../api';

export default function Baustellen() {
  const auth = useAuth() || {}; const user = auth.user;
  const isAdmin = user?.role === 'admin';
  const [items, setItems] = useState([]);
  const [editing, setEditing] = useState(null);
  const [showForm, setShowForm] = useState(false);
  const [filter, setFilter] = useState('');

  const load = () => api.get('/baustellen').then(r => setItems(Array.isArray(r.data) ? r.data : [])).catch(() => setItems([]));
  useEffect(() => { let m = true; api.get('/baustellen').then(r => { if (m) setItems(Array.isArray(r.data) ? r.data : []); }).catch(() => { if (m) setItems([]); }); return () => { m = false; }; }, []);

  const filtered = items.filter(b => !filter || b.name?.toLowerCase().includes(filter.toLowerCase()) || b.adresse?.toLowerCase().includes(filter.toLowerCase()));

  const save = async (data) => {
    if (editing?.id) await api.put(`/baustellen/${editing.id}`, data);
    else await api.post('/baustellen', data);
    setShowForm(false); setEditing(null);
    load();
  };

  const remove = async (id) => {
    if (!window.confirm('Baustelle wirklich löschen?')) return;
    await api.delete(`/baustellen/${id}`);
    load();
  };

  return (
    <div>
      <div className="page-header">
        <div>
          <div className="page-title">Baustellen</div>
          <div className="page-sub">{items.length} aktive Baustellen</div>
        </div>
        <button className="btn btn-primary" onClick={() => { setEditing({}); setShowForm(true); }}>+ Neue Baustelle</button>
      </div>

      <div className="card">
        <div className="card-head">
          <input className="form-input" placeholder="🔍 Suchen…" value={filter} onChange={e => setFilter(e.target.value)} style={{ maxWidth: 280 }} />
        </div>

        {filtered.length === 0 ? (
          <div className="empty"><div className="empty-icon">🏗️</div><h3>Keine Baustellen</h3><p>Oben neue Baustelle hinzufügen</p></div>
        ) : (
          <div className="table-wrap table-mobile-stack">
            <table>
              <thead>
                <tr><th>Name</th><th>Adresse</th><th>Auftraggeber</th><th>Bauleiter</th>{isAdmin && <th></th>}</tr>
              </thead>
              <tbody>
                {filtered.map(b => (
                  <tr key={b.id}>
                    <td data-label="" className="td-title" style={{ fontWeight: 500 }}>{b.name}</td>
                    <td data-label="Adresse">{[b.adresse, b.plz, b.ort].filter(Boolean).join(', ') || '–'}</td>
                    <td data-label="Auftraggeber">{b.auftraggeber || '–'}</td>
                    <td data-label="Bauleiter">{b.bauleiter || '–'}</td>
                    {isAdmin && (
                      <td data-label="" className="td-actions">
                        <button className="btn btn-secondary btn-sm" onClick={() => { setEditing(b); setShowForm(true); }}>✏️</button>
                        <button className="btn btn-danger btn-sm" onClick={() => remove(b.id)}>🗑</button>
                      </td>
                    )}
                  </tr>
                ))}
              </tbody>
            </table>
          </div>
        )}
      </div>

      {showForm && <BaustelleForm item={editing} onClose={() => { setShowForm(false); setEditing(null); }} onSave={save} />}
    </div>
  );
}

function BaustelleForm({ item, onClose, onSave }) {
  const [data, setData] = useState({
    name: item.name || '',
    adresse: item.adresse || '',
    plz: item.plz || '',
    ort: item.ort || '',
    auftraggeber: item.auftraggeber || '',
    bauleiter: item.bauleiter || '',
    notizen: item.notizen || '',
  });

  return (
    <div style={{ position: 'fixed', inset: 0, background: 'rgba(0,0,0,0.5)', display: 'flex', alignItems: 'center', justifyContent: 'center', zIndex: 100, padding: 20 }} onClick={onClose}>
      <div className="card" style={{ maxWidth: 600, width: '100%', margin: 0, maxHeight: '90vh', overflowY: 'auto' }} onClick={e => e.stopPropagation()}>
        <div className="card-title" style={{ marginBottom: 14 }}>{item.id ? 'Baustelle bearbeiten' : 'Neue Baustelle'}</div>
        <div className="form-group" style={{ marginBottom: 10 }}><label className="form-label">Name</label><input className="form-input" value={data.name} onChange={e => setData({...data, name: e.target.value})} required /></div>
        <div className="form-group" style={{ marginBottom: 10 }}><label className="form-label">Adresse</label><input className="form-input" value={data.adresse} onChange={e => setData({...data, adresse: e.target.value})} /></div>
        <div className="form-grid form-grid-2" style={{ marginBottom: 10 }}>
          <div className="form-group"><label className="form-label">PLZ</label><input className="form-input" value={data.plz} onChange={e => setData({...data, plz: e.target.value})} /></div>
          <div className="form-group"><label className="form-label">Ort</label><input className="form-input" value={data.ort} onChange={e => setData({...data, ort: e.target.value})} /></div>
        </div>
        <div className="form-grid form-grid-2" style={{ marginBottom: 10 }}>
          <div className="form-group"><label className="form-label">Auftraggeber</label><input className="form-input" value={data.auftraggeber} onChange={e => setData({...data, auftraggeber: e.target.value})} /></div>
          <div className="form-group"><label className="form-label">Bauleiter</label><input className="form-input" value={data.bauleiter} onChange={e => setData({...data, bauleiter: e.target.value})} /></div>
        </div>
        <div className="form-group" style={{ marginBottom: 14 }}><label className="form-label">Notizen</label><textarea className="form-textarea" value={data.notizen} onChange={e => setData({...data, notizen: e.target.value})} /></div>
        <div style={{ display: 'flex', gap: 8, justifyContent: 'flex-end' }}>
          <button className="btn btn-secondary" onClick={onClose}>Abbrechen</button>
          <button className="btn btn-primary" onClick={() => onSave(data)}>Speichern</button>
        </div>
      </div>
    </div>
  );
}
